// mock/data.js
export const mockPosts = [
  {
    id: 1,
    title: "欢迎来到我的博客",
    author: "博主",
    publishedDate: "2023-01-01T10:00:00Z",
    content:
      "这是我的第一篇博客文章，欢迎大家阅读。在这篇文章中，我将介绍本博客的主要内容和方向。希望你能在这里找到有价值的信息。",
    tags: ["介绍", "博客"],
    views: 120,
    categoryId: 1,
    comments: [
      {
        id: 1,
        author: "访客A",
        content: "很好的介绍，期待更多内容！",
        createdAt: "2023-01-02T15:30:00Z",
      },
      {
        id: 2,
        author: "访客B",
        content: "加油，会持续关注的！",
        createdAt: "2023-01-03T09:15:00Z",
      },
    ],
  },
  {
    id: 2,
    title: "如何使用Ant Design构建现代化界面",
    author: "博主",
    publishedDate: "2023-01-05T14:20:00Z",
    content:
      "Ant Design是一套企业级UI设计语言和React组件库。它提供了一套高质量的React组件，可以帮助我们快速搭建美观且易用的界面。\n\n主要特性包括：\n1. 丰富的组件库\n2. 完善的设计规范\n3. 强大的主题定制能力\n4. 国际化支持\n\n在本文中，我们将详细介绍如何在项目中集成和使用Ant Design。",
    tags: ["React", "UI框架", "前端"],
    views: 280,
    categoryId: 2,
    comments: [
      {
        id: 3,
        author: "前端工程师",
        content: "非常实用的指南，感谢分享！",
        createdAt: "2023-01-06T11:45:00Z",
      },
    ],
  },
  {
    id: 3,
    title: "React Hooks完全指南",
    author: "博主",
    publishedDate: "2023-01-10T09:00:00Z",
    content:
      "React Hooks是React 16.8版本引入的新特性，它可以让你在不编写class的情况下使用state以及其他React特性。\n\n常用的Hooks包括：\n- useState: 状态管理\n- useEffect: 副作用处理\n- useContext: 上下文处理\n- useReducer: 状态逻辑管理\n\n本文将详细讲解每个Hook的使用方法和最佳实践。",
    tags: ["React", "Hooks", "前端"],
    views: 450,
    categoryId: 2,
    comments: [],
  },
  {
    id: 4,
    title: "深入理解JavaScript闭包",
    author: "博主",
    publishedDate: "2023-01-15T16:30:00Z",
    content:
      "闭包是JavaScript中的一个重要概念，也是面试中的高频考点。理解闭包对于编写高质量的JavaScript代码至关重要。\n\n闭包的三个关键点：\n1. 函数嵌套函数\n2. 内部函数可以访问外部函数的变量\n3. 即使外部函数已经返回，内部函数仍然可以访问外部函数的变量\n\n通过实例分析闭包的应用场景和注意事项。",
    tags: ["JavaScript", "前端"],
    views: 320,
    categoryId: 2,
    comments: [
      {
        id: 4,
        author: "JS爱好者",
        content: "讲得很清楚，终于明白了闭包的概念！",
        createdAt: "2023-01-16T10:20:00Z",
      },
      {
        id: 5,
        author: "初学者",
        content: "能不能再详细解释一下闭包的内存泄漏问题？",
        createdAt: "2023-01-17T14:05:00Z",
      },
    ],
  },
];

export const mockCategories = [
  { id: 1, name: "生活随笔", postCount: 5 },
  { id: 2, name: "技术分享", postCount: 12 },
  { id: 3, name: "学习笔记", postCount: 8 },
];

export const mockTags = [
  { id: 1, name: "React", count: 8 },
  { id: 2, name: "JavaScript", count: 10 },
  { id: 3, name: "前端", count: 15 },
  { id: 4, name: "UI框架", count: 3 },
  { id: 5, name: "介绍", count: 2 },
  { id: 6, name: "博客", count: 2 },
];

export const mockUsers = [
  { id: 1, username: "博主", email: "author@example.com", role: "admin" },
  { id: 2, username: "访客A", email: "visitorA@example.com", role: "user" },
];
